{
  "name": "Nuke Button",
  "powerupName": "TheNuke",
  "levelUpDescriptions": [
    "NukeUpgradeDescription1",
    "NukeUpgradeDescription2",
    "NukeUpgradeDescription3",
    "NukeUpgradeDescription4",
    "NukeUpgradeDescription5"
  ]
}